const { useContext, createContext } = require("react");

const DashboardContext = createContext();

export default DashboardContext;
